module.exports = __webpack_public_path__ + "img/icon-upgrade-alt.589e3fb0.svg";